// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  // --- FRANÇAIS (FR) ---
  fr: {
    translation: {
      // =========================
      // EXISTANT - HOME / RÉGIONS
      // =========================
      "hero_title": "Votre Aventure au <1>Québec</1> Commence Ici",
      "hero_subtitle": "Explorez les 17 régions touristiques, de la métropole vibrante aux grands espaces sauvages.",
      "cta_explore": "Commencer l'exploration",
      "regions_title": "Choisissez votre destination",
      "regions_subtitle": "Cliquez sur une région pour voir la carte",
      "map_active_region": "Région Active",
      "filter_title": "Filtrer par activité",
      "places_found": "{{count}} lieux trouvés",
      "footer_rights": "Tous droits réservés.",
      "nav_home": "Accueil",
      "nav_regions": "Régions",
      "nav_map": "Carte Interactive",

      "cat_transport_name": "Se Déplacer",
      "cat_transport_desc": "Taxi, Uber, Location, Bus",
      "cat_restauration_name": "Se Restaurer",
      "cat_restauration_desc": "Restos, Cafés, Microbrasseries",
      "cat_magasinage_name": "Magasiner",
      "cat_magasinage_desc": "Boutiques, Souvenirs, Mode",
      "cat_activites_name": "Activités & Loisirs",
      "cat_activites_desc": "Musées, Parcs, Festivals, Ski",
      "cat_hebergement_name": "Hébergement",
      "cat_hebergement_desc": "Hôtels, Auberges, Chalets",

      "reg_capitale-nationale_desc": "Le cœur historique du Québec, mêlant patrimoine mondial et nature grandiose.",
      "reg_montreal_desc": "La métropole vibrante, reconnue pour sa culture, sa gastronomie et ses festivals.",
      "reg_gaspesie_desc": "Une péninsule légendaire offrant mer, montagnes et le célèbre Rocher Percé.",
      "reg_laurentides_desc": "La destination de villégiature par excellence avec ses lacs et ses stations de ski.",
      "reg_outaouais_desc": "Porte d'entrée de l'ouest québécois, riche en forêts et musées nationaux.",
      "reg_saguenay-lac-saint-jean_desc": "Le royaume du fjord et du bleuet, offrant des paysages démesurés.",
      "reg_charlevoix_desc": "Entre fleuve et montagnes, une région inspirante pour les artistes et gourmets.",

      // =========================
      // COMMUN
      // =========================
      common: {
        new: "Nouveau",
        local: "Local",
        close: "Fermer",
        open: "Ouvrir",
        loading: "Chargement",
        error: "Erreur",
        retry: "Réessayer",
        continue: "Continuer",
        confirm: "Confirmer",
        cancel: "Annuler",
        save: "Sauvegarder",
        back: "Retour",
        next: "Suivant",
        previous: "Précédent",
      },

      // =========================
      // LANGUE
      // =========================
      language: {
        label: "Langue",
        switcherLabel: "Changer la langue",
        french: "Français",
        english: "English",
      },

      // =========================
      // NAVIGATION GLOBALE
      // =========================
      navigation: {
        home: "Accueil",
        backHome: "Retour à l’accueil",
        backPrevious: "Retour à la page précédente",
        homeShort: "Accueil",
        about: "À propos",
        customerService: "Service client",
        howItWorks: "Comment ça marche",
        trust: "Confiance",
        help: "Aide",
        partners: "Partenaires",
        giftCard: "Carte-cadeau",
        infoHub: "Infos",
        security: "Sécurité",
        howItWorksSubtitle: "Comprendre Forfeo",
        securitySubtitle: "Confiance & paiements",
        helpSubtitle: "FAQ & support",
        explore: "Explorer",
        deals: "Bons Plans",
        search: "Recherche",
        login: "Connexion",
        logout: "Déconnexion",
        myAccount: "Mon compte",
        dashboard: "Tableau de bord",
        dashboardSubtitle: "Vue d’ensemble",
        connectedSpace: "Espace connecté",
        myReservations: "Mes réservations",
        myReservationsSubtitle: "Last Call et expériences",
        myPurchases: "Mes achats",
        myPurchasesSubtitle: "Commandes et cartes",
        myFavorites: "Mes favoris",
        myFavoritesSubtitle: "Offres sauvegardées",
        myAlerts: "Mes alertes",
        myAlertsSubtitle: "Forfeo Évasion",
        openMenu: "Ouvrir le menu",
        closeMenu: "Fermer le menu",
        quickNavigation: "Navigation rapide",

        habitatSubtitle: "Location au Québec",
        habitatMobileSubtitle: "Location résidentielle",

        passport: "Mon Passeport Forfeo",
        accommodations: "Nos Hébergements",
        hotels: "Hôtels",
        interactiveMap: "Carte interactive",
        toolbox: "La Boîte à Outils",
        toolboxShort: "La Boîte à\nOutils",
        localNetwork: "Réseau Local",
        registerBusiness: "Inscrire mon Entreprise",
        businessSpace: "Espace Entreprise",

        dropsSubtitle: "Récompenses géolocalisées",
        vipPresale: "Prévente VIP",
        vipPresaleSubtitle: "Forfaits limités & accès sécurisé",
        shop: "Boutique Forfeo",
        shopSubtitle: "Forfaits et expériences",
        dealsShop: "Bons Plans (Boutique)",
        findsSubtitle: "Découvertes exclusives",
        evasion: "Évasion",
        evasionSubtitle: "Alertes voyage & vols",
        flashDeals: "Offres Flash",
        flash: "Flash",
        lastCallSubtitle: "Dernière minute (Last Call)",
        clubSubtitle: "Avantages et récompenses",
        regions: "Nos Régions",
      },

      // =========================
      // PANIER
      // =========================
      cart: {
        open: "Ouvrir le panier",
        title: "Votre panier",
        empty: "Votre panier est vide",
        checkout: "Passer au paiement",
        subtotal: "Sous-total",
        taxes: "Taxes",
        total: "Total",
      },

      // =========================
      // ACCESSIBILITÉ
      // =========================
      accessibility: {
        mainNavigation: "Navigation principale",
        closeModal: "Fermer la fenêtre",
        openSearch: "Ouvrir la recherche",
      },
    }
  },

  // --- ANGLAIS (EN) ---
  en: {
    translation: {
      // =========================
      // EXISTING - HOME / REGIONS
      // =========================
      "hero_title": "Your Adventure in <1>Quebec</1> Starts Here",
      "hero_subtitle": "Explore the 17 tourist regions, from the vibrant metropolis to the great wild outdoors.",
      "cta_explore": "Start Exploring",
      "regions_title": "Choose Your Destination",
      "regions_subtitle": "Click on a region to view the map",
      "map_active_region": "Active Region",
      "filter_title": "Filter by Activity",
      "places_found": "{{count}} places found",
      "footer_rights": "All rights reserved.",
      "nav_home": "Home",
      "nav_regions": "Regions",
      "nav_map": "Interactive Map",

      "cat_transport_name": "Getting Around",
      "cat_transport_desc": "Taxi, Uber, Rental, Bus",
      "cat_restauration_name": "Eat & Drink",
      "cat_restauration_desc": "Restaurants, Cafes, Breweries",
      "cat_magasinage_name": "Shopping",
      "cat_magasinage_desc": "Shops, Souvenirs, Fashion",
      "cat_activites_name": "Activities",
      "cat_activites_desc": "Museums, Parks, Festivals, Ski",
      "cat_hebergement_name": "Accommodation",
      "cat_hebergement_desc": "Hotels, Inns, Chalets",

      "reg_capitale-nationale_desc": "The historic heart of Quebec, blending world heritage and grand nature.",
      "reg_montreal_desc": "The vibrant metropolis, renowned for its culture, gastronomy, and festivals.",
      "reg_gaspesie_desc": "A legendary peninsula offering sea, mountains, and the famous Percé Rock.",
      "reg_laurentides_desc": "The ultimate resort destination with its lakes and ski resorts.",
      "reg_outaouais_desc": "Gateway to western Quebec, rich in forests and national museums.",
      "reg_saguenay-lac-saint-jean_desc": "The kingdom of the fjord and blueberries, offering oversized landscapes.",
      "reg_charlevoix_desc": "Between river and mountains, an inspiring region for artists and foodies.",

      // =========================
      // COMMON
      // =========================
      common: {
        new: "New",
        local: "Local",
        close: "Close",
        open: "Open",
        loading: "Loading",
        error: "Error",
        retry: "Try again",
        continue: "Continue",
        confirm: "Confirm",
        cancel: "Cancel",
        save: "Save",
        back: "Back",
        next: "Next",
        previous: "Previous",
      },

      // =========================
      // LANGUAGE
      // =========================
      language: {
        label: "Language",
        switcherLabel: "Change language",
        french: "Français",
        english: "English",
      },

      // =========================
      // GLOBAL NAVIGATION
      // =========================
      navigation: {
        home: "Home",
        backHome: "Back to home",
        backPrevious: "Back to previous page",
        homeShort: "Home",
        about: "About",
        customerService: "Customer service",
        howItWorks: "How it works",
        trust: "Trust",
        help: "Help",
        partners: "Partners",
        giftCard: "Gift card",
        infoHub: "Info",
        security: "Security",
        howItWorksSubtitle: "Understand Forfeo",
        securitySubtitle: "Trust & payments",
        helpSubtitle: "FAQ & support",
        explore: "Explore",
        deals: "Deals",
        search: "Search",
        login: "Sign in",
        logout: "Sign out",
        myAccount: "My account",
        dashboard: "Dashboard",
        dashboardSubtitle: "Overview",
        connectedSpace: "Connected space",
        myReservations: "My reservations",
        myReservationsSubtitle: "Last Call and experiences",
        myPurchases: "My purchases",
        myPurchasesSubtitle: "Orders and cards",
        myFavorites: "My favorites",
        myFavoritesSubtitle: "Saved offers",
        myAlerts: "My alerts",
        myAlertsSubtitle: "Forfeo Escape",
        openMenu: "Open menu",
        closeMenu: "Close menu",
        quickNavigation: "Quick navigation",

        habitatSubtitle: "Rentals in Quebec",
        habitatMobileSubtitle: "Residential rentals",

        passport: "My Forfeo Passport",
        accommodations: "Our Accommodations",
        hotels: "Hotels",
        interactiveMap: "Interactive map",
        toolbox: "Travel Toolbox",
        toolboxShort: "Travel\nToolbox",
        localNetwork: "Local Network",
        registerBusiness: "Register my Business",
        businessSpace: "Business Space",

        dropsSubtitle: "Geolocated rewards",
        vipPresale: "VIP Presale",
        vipPresaleSubtitle: "Limited packages & secure access",
        shop: "Forfeo Shop",
        shopSubtitle: "Packages and experiences",
        dealsShop: "Deals Shop",
        findsSubtitle: "Exclusive discoveries",
        evasion: "Escape",
        evasionSubtitle: "Travel & flight alerts",
        flashDeals: "Flash Deals",
        flash: "Flash",
        lastCallSubtitle: "Last-minute offers",
        clubSubtitle: "Benefits and rewards",
        regions: "Our Regions",
      },

      // =========================
      // CART
      // =========================
      cart: {
        open: "Open cart",
        title: "Your cart",
        empty: "Your cart is empty",
        checkout: "Go to checkout",
        subtotal: "Subtotal",
        taxes: "Taxes",
        total: "Total",
      },

      // =========================
      // ACCESSIBILITY
      // =========================
      accessibility: {
        mainNavigation: "Main navigation",
        closeModal: "Close window",
        openSearch: "Open search",
      },
    }
  },

  // --- ESPAGNOL (ES) ---
  es: {
    translation: {
      "hero_title": "Tu Aventura en <1>Quebec</1> Comienza Aquí",
      "hero_subtitle": "Explora las 17 regiones turísticas, desde la vibrante metrópolis hasta los grandes espacios salvajes.",
      "cta_explore": "Comenzar a Explorar",
      "regions_title": "Elige tu Destino",
      "regions_subtitle": "Haz clic en una región para ver el mapa",
      "map_active_region": "Región Activa",
      "filter_title": "Filtrar por Actividad",
      "places_found": "{{count}} lugares encontrados",
      "footer_rights": "Todos los derechos reservados.",
      "nav_home": "Inicio",
      "nav_regions": "Regiones",
      "nav_map": "Mapa Interactivo",

      "cat_transport_name": "Transporte",
      "cat_transport_desc": "Taxi, Uber, Alquiler, Autobús",
      "cat_restauration_name": "Gastronomía",
      "cat_restauration_desc": "Restaurantes, Cafés, Cervecerías",
      "cat_magasinage_name": "Compras",
      "cat_magasinage_desc": "Tiendas, Recuerdos, Moda",
      "cat_activites_name": "Actividades",
      "cat_activites_desc": "Museos, Parques, Festivales, Esquí",
      "cat_hebergement_name": "Alojamiento",
      "cat_hebergement_desc": "Hoteles, Posadas, Cabañas",

      "reg_capitale-nationale_desc": "El corazón histórico de Quebec, mezclando patrimonio mundial y naturaleza grandiosa.",
      "reg_montreal_desc": "La metrópoli vibrante, reconocida por su cultura, gastronomía y festivales.",
      "reg_gaspesie_desc": "Una península legendaria que ofrece mar, montañas y la famosa Roca Percé.",
      "reg_laurentides_desc": "El destino vacacional por excelencia con sus lagos y estaciones de esquí.",
      "reg_outaouais_desc": "Puerta de entrada al oeste de Quebec, rica en bosques y museos nacionales.",
      "reg_saguenay-lac-saint-jean_desc": "El reino del fiordo y los arándanos, con paisajes desmesurados.",
      "reg_charlevoix_desc": "Entre río y montaña, una región inspiradora para artistas y gourmets.",

      common: {
        new: "Nuevo",
        local: "Local",
        close: "Cerrar",
        open: "Abrir",
        loading: "Cargando",
        error: "Error",
        retry: "Intentar de nuevo",
        continue: "Continuar",
        confirm: "Confirmar",
        cancel: "Cancelar",
        save: "Guardar",
        back: "Atrás",
        next: "Siguiente",
        previous: "Anterior",
      },

      language: {
        label: "Idioma",
        switcherLabel: "Cambiar idioma",
        french: "Français",
        english: "English",
      },

      navigation: {
        home: "Inicio",
        backHome: "Volver al inicio",
        backPrevious: "Volver a la página anterior",
        homeShort: "Inicio",
        about: "Acerca de",
        customerService: "Atención al cliente",
        explore: "Explorar",
        deals: "Ofertas",
        search: "Buscar",
        login: "Iniciar sesión",
        logout: "Cerrar sesión",
        openMenu: "Abrir menú",
        closeMenu: "Cerrar menú",
        quickNavigation: "Navegación rápida",

        habitatSubtitle: "Alquiler en Quebec",
        habitatMobileSubtitle: "Alquiler residencial",

        passport: "Mi Pasaporte Forfeo",
        accommodations: "Nuestros Alojamientos",
        hotels: "Hoteles",
        interactiveMap: "Mapa interactivo",
        toolbox: "Caja de herramientas",
        toolboxShort: "Caja de\nherramientas",
        localNetwork: "Red Local",
        registerBusiness: "Registrar mi Empresa",
        businessSpace: "Espacio Empresa",

        dropsSubtitle: "Recompensas geolocalizadas",
        vipPresale: "Preventa VIP",
        vipPresaleSubtitle: "Paquetes limitados y acceso seguro",
        shop: "Tienda Forfeo",
        shopSubtitle: "Paquetes y experiencias",
        dealsShop: "Ofertas (Tienda)",
        findsSubtitle: "Descubrimientos exclusivos",
        evasion: "Evasión",
        evasionSubtitle: "Alertas de viaje y vuelos",
        flashDeals: "Ofertas Flash",
        flash: "Flash",
        lastCallSubtitle: "Último minuto",
        clubSubtitle: "Beneficios y recompensas",
        regions: "Nuestras Regiones",
      },

      cart: {
        open: "Abrir carrito",
        title: "Tu carrito",
        empty: "Tu carrito está vacío",
        checkout: "Ir al pago",
        subtotal: "Subtotal",
        taxes: "Impuestos",
        total: "Total",
      },

      accessibility: {
        mainNavigation: "Navegación principal",
        closeModal: "Cerrar ventana",
        openSearch: "Abrir búsqueda",
      },
    }
  },

  // --- ALLEMAND (DE) ---
  de: {
    translation: {
      "hero_title": "Ihr Abenteuer in <1>Quebec</1> Beginnt Hier",
      "hero_subtitle": "Entdecken Sie die 17 touristischen Regionen, von der pulsierenden Metropole bis zur wilden Natur.",
      "cta_explore": "Erkundung Starten",
      "regions_title": "Wählen Sie Ihr Reiseziel",
      "regions_subtitle": "Klicken Sie auf eine Region, um die Karte anzuzeigen",
      "map_active_region": "Aktive Region",
      "filter_title": "Nach Aktivität filtern",
      "places_found": "{{count}} Orte gefunden",
      "footer_rights": "Alle Rechte vorbehalten.",
      "nav_home": "Startseite",
      "nav_regions": "Regionen",
      "nav_map": "Interaktive Karte",

      "cat_transport_name": "Transport",
      "cat_transport_desc": "Taxi, Uber, Mietwagen, Bus",
      "cat_restauration_name": "Essen & Trinken",
      "cat_restauration_desc": "Restaurants, Cafés, Brauereien",
      "cat_magasinage_name": "Einkaufen",
      "cat_magasinage_desc": "Geschäfte, Souvenirs, Mode",
      "cat_activites_name": "Aktivitäten",
      "cat_activites_desc": "Museen, Parks, Festivals, Ski",
      "cat_hebergement_name": "Unterkunft",
      "cat_hebergement_desc": "Hotels, Gasthöfe, Chalets",

      "reg_capitale-nationale_desc": "Das historische Herz von Quebec, eine Mischung aus Weltkulturerbe und grandioser Natur.",
      "reg_montreal_desc": "Die pulsierende Metropole, bekannt für ihre Kultur, Gastronomie und Festivals.",
      "reg_gaspesie_desc": "Eine legendäre Halbinsel mit Meer, Bergen und dem berühmten Rocher Percé.",
      "reg_laurentides_desc": "Das Urlaubsziel schlechthin mit seinen Seen und Skigebieten.",
      "reg_outaouais_desc": "Das Tor zum Westen Quebecs, reich an Wäldern und Nationalmuseen.",
      "reg_saguenay-lac-saint-jean_desc": "Das Königreich des Fjords und der Blaubeeren mit riesigen Landschaften.",
      "reg_charlevoix_desc": "Zwischen Fluss und Bergen, eine inspirierende Region für Künstler und Feinschmecker.",

      common: {
        new: "Neu",
        local: "Lokal",
        close: "Schließen",
        open: "Öffnen",
        loading: "Wird geladen",
        error: "Fehler",
        retry: "Erneut versuchen",
        continue: "Weiter",
        confirm: "Bestätigen",
        cancel: "Abbrechen",
        save: "Speichern",
        back: "Zurück",
        next: "Weiter",
        previous: "Zurück",
      },

      language: {
        label: "Sprache",
        switcherLabel: "Sprache ändern",
        french: "Français",
        english: "English",
      },

      navigation: {
        home: "Startseite",
        backHome: "Zurück zur Startseite",
        backPrevious: "Zurück zur vorherigen Seite",
        homeShort: "Start",
        about: "Über uns",
        customerService: "Kundenservice",
        explore: "Entdecken",
        deals: "Angebote",
        search: "Suche",
        login: "Anmelden",
        logout: "Abmelden",
        openMenu: "Menü öffnen",
        closeMenu: "Menü schließen",
        quickNavigation: "Schnellnavigation",

        habitatSubtitle: "Vermietungen in Quebec",
        habitatMobileSubtitle: "Wohnungsvermietung",

        passport: "Mein Forfeo-Pass",
        accommodations: "Unsere Unterkünfte",
        hotels: "Hotels",
        interactiveMap: "Interaktive Karte",
        toolbox: "Reise-Toolbox",
        toolboxShort: "Reise-\nToolbox",
        localNetwork: "Lokales Netzwerk",
        registerBusiness: "Mein Unternehmen registrieren",
        businessSpace: "Unternehmensbereich",

        dropsSubtitle: "Geolokalisierte Belohnungen",
        vipPresale: "VIP-Vorverkauf",
        vipPresaleSubtitle: "Limitierte Pakete & sicherer Zugang",
        shop: "Forfeo-Shop",
        shopSubtitle: "Pakete und Erlebnisse",
        dealsShop: "Angebote (Shop)",
        findsSubtitle: "Exklusive Entdeckungen",
        evasion: "Auszeit",
        evasionSubtitle: "Reise- und Flugbenachrichtigungen",
        flashDeals: "Flash-Angebote",
        flash: "Flash",
        lastCallSubtitle: "Last-Minute-Angebote",
        clubSubtitle: "Vorteile und Belohnungen",
        regions: "Unsere Regionen",
      },

      cart: {
        open: "Warenkorb öffnen",
        title: "Ihr Warenkorb",
        empty: "Ihr Warenkorb ist leer",
        checkout: "Zur Kasse",
        subtotal: "Zwischensumme",
        taxes: "Steuern",
        total: "Gesamt",
      },

      accessibility: {
        mainNavigation: "Hauptnavigation",
        closeModal: "Fenster schließen",
        openSearch: "Suche öffnen",
      },
    }
  },

  // --- ITALIEN (IT) ---
  it: {
    translation: {
      "hero_title": "La Tua Avventura in <1>Quebec</1> Inizia Qui",
      "hero_subtitle": "Esplora le 17 regioni turistiche, dalla vibrante metropoli ai grandi spazi selvaggi.",
      "cta_explore": "Inizia a Esplorare",
      "regions_title": "Scegli la tua Destinazione",
      "regions_subtitle": "Clicca su una regione per vedere la mappa",
      "map_active_region": "Regione Attiva",
      "filter_title": "Filtra per Attività",
      "places_found": "{{count}} luoghi trovati",
      "footer_rights": "Tutti i diritti riservati.",
      "nav_home": "Home",
      "nav_regions": "Regioni",
      "nav_map": "Mappa Interattiva",

      "cat_transport_name": "Trasporti",
      "cat_transport_desc": "Taxi, Uber, Noleggio, Bus",
      "cat_restauration_name": "Ristorazione",
      "cat_restauration_desc": "Ristoranti, Caffè, Birrerie",
      "cat_magasinage_name": "Shopping",
      "cat_magasinage_desc": "Negozi, Souvenir, Moda",
      "cat_activites_name": "Attività",
      "cat_activites_desc": "Musei, Parchi, Festival, Sci",
      "cat_hebergement_name": "Alloggio",
      "cat_hebergement_desc": "Hotel, Locande, Chalet",

      "reg_capitale-nationale_desc": "Il cuore storico del Quebec, che unisce patrimonio mondiale e natura grandiosa.",
      "reg_montreal_desc": "La metropoli vibrante, rinomata per la sua cultura, gastronomia e festival.",
      "reg_gaspesie_desc": "Una penisola leggendaria che offre mare, montagne e la famosa Roccia di Percé.",
      "reg_laurentides_desc": "La destinazione turistica per eccellenza con i suoi laghi e le stazioni sciistiche.",
      "reg_outaouais_desc": "Porta d'ingresso al Quebec occidentale, ricca di foreste e musei nazionali.",
      "reg_saguenay-lac-saint-jean_desc": "Il regno del fiordo e dei mirtilli, che offre paesaggi smisurati.",
      "reg_charlevoix_desc": "Tra fiume e montagne, una regione stimolante per artisti e buongustai.",

      common: {
        new: "Nuovo",
        local: "Locale",
        close: "Chiudi",
        open: "Apri",
        loading: "Caricamento",
        error: "Errore",
        retry: "Riprova",
        continue: "Continua",
        confirm: "Conferma",
        cancel: "Annulla",
        save: "Salva",
        back: "Indietro",
        next: "Avanti",
        previous: "Precedente",
      },

      language: {
        label: "Lingua",
        switcherLabel: "Cambia lingua",
        french: "Français",
        english: "English",
      },

      navigation: {
        home: "Home",
        backHome: "Torna alla home",
        backPrevious: "Torna alla pagina precedente",
        homeShort: "Home",
        about: "Chi siamo",
        customerService: "Servizio clienti",
        explore: "Esplora",
        deals: "Offerte",
        search: "Cerca",
        login: "Accedi",
        logout: "Esci",
        openMenu: "Apri menu",
        closeMenu: "Chiudi menu",
        quickNavigation: "Navigazione rapida",

        habitatSubtitle: "Affitti in Quebec",
        habitatMobileSubtitle: "Affitti residenziali",

        passport: "Il mio Passaporto Forfeo",
        accommodations: "I nostri Alloggi",
        hotels: "Hotel",
        interactiveMap: "Mappa interattiva",
        toolbox: "Strumenti viaggio",
        toolboxShort: "Strumenti\nviaggio",
        localNetwork: "Rete Locale",
        registerBusiness: "Registra la mia Attività",
        businessSpace: "Spazio Azienda",

        dropsSubtitle: "Ricompense geolocalizzate",
        vipPresale: "Prevendita VIP",
        vipPresaleSubtitle: "Pacchetti limitati e accesso sicuro",
        shop: "Negozio Forfeo",
        shopSubtitle: "Pacchetti ed esperienze",
        dealsShop: "Offerte (Negozio)",
        findsSubtitle: "Scoperte esclusive",
        evasion: "Evasione",
        evasionSubtitle: "Avvisi viaggio e voli",
        flashDeals: "Offerte Flash",
        flash: "Flash",
        lastCallSubtitle: "Ultimo minuto",
        clubSubtitle: "Vantaggi e premi",
        regions: "Le nostre Regioni",
      },

      cart: {
        open: "Apri carrello",
        title: "Il tuo carrello",
        empty: "Il tuo carrello è vuoto",
        checkout: "Vai al pagamento",
        subtotal: "Subtotale",
        taxes: "Tasse",
        total: "Totale",
      },

      accessibility: {
        mainNavigation: "Navigazione principale",
        closeModal: "Chiudi finestra",
        openSearch: "Apri ricerca",
      },
    }
  }
};

const savedLanguage =
  typeof window !== 'undefined'
    ? window.localStorage.getItem('forfeo_language')
    : null;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'es', 'de', 'it'],
    load: 'languageOnly',
    lng: savedLanguage || undefined,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'forfeo_language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
